import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  OnInit,
  ViewContainerRef,
  inject,
  input,
  viewChild,
} from '@angular/core';

import { IdentityProviderFactory } from 'ish-core/identity-provider/identity-provider.factory';
import { Auth0SignInComponent } from 'ish-shared/components/login/auth0-sign-in/auth0-sign-in.component';
import { LoginFormComponent } from 'ish-shared/components/login/login-form/login-form.component';

@Component({
  selector: 'ish-identity-provider-login',
  templateUrl: './identity-provider-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdentityProviderLoginComponent implements OnInit {
  private identityProviderFactory = inject(IdentityProviderFactory);

  readonly labelClass = input<string>(undefined);
  readonly inputClass = input<string>(undefined);
  readonly forgotPasswordClass = input<string>(undefined);
  readonly signInClass = input<string>(undefined);

  readonly anchor = viewChild('anchor', { read: ViewContainerRef });

  ngOnInit() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let componentRef: ComponentRef<any>;

    switch (this.identityProviderFactory.getType()) {
      case 'auth0':
        componentRef = this.anchor().createComponent(Auth0SignInComponent);
        break;

      default:
        componentRef = this.anchor().createComponent(LoginFormComponent);
        break;
    }

    componentRef.setInput('labelClass', this.labelClass());
    componentRef.setInput('inputClass', this.inputClass());
    componentRef.setInput('forgotPasswordClass', this.forgotPasswordClass());
    componentRef.setInput('signInClass', this.signInClass());

    componentRef.changeDetectorRef.markForCheck();
  }
}
